import React, { useState, useEffect } from 'react';
import { api } from './App';
import { Clipboard } from './Icons';

export default function Feedback() {
  const [items, setItems] = useState([]);
  const [text, setText] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => { api('/api/feedback').then(setItems); }, []);

  const submit = async () => {
    if (!text.trim()) return;
    setSaving(true);
    await api('/api/feedback', { method: 'POST', body: JSON.stringify({ text }) });
    setText('');
    const updated = await api('/api/feedback');
    setItems(updated);
    setSaving(false);
  };

  const resolve = async (id) => {
    await api(`/api/feedback/${id}/resolve`, { method: 'POST' });
    setItems(prev => prev.map(f => f.id === id ? { ...f, resolved: 1 } : f));
  };

  const unresolved = items.filter(f => !f.resolved);
  const resolved = items.filter(f => f.resolved);

  const copyFeedback = () => {
    const text = unresolved.map(f => `• ${f.created_at}: ${f.text}`).join('\n');
    navigator.clipboard.writeText(`Holly's SQE tracker feedback / change requests:\n\n${text}`);
  };

  return (
    <div className="feedback-page">
      <div className="feedback-intro">
        <div className="feedback-title">Feedback & change requests</div>
        <p className="feedback-desc">Note anything you'd like changed or improved.</p>
      </div>

      <div className="feedback-input-section">
        <textarea className="feedback-textarea" placeholder="Describe the change or improvement you'd like…"
          value={text} onChange={e => setText(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && e.metaKey) submit(); }} />
        <div className="feedback-input-row">
          <span style={{ fontSize: 11, color: 'var(--hint)' }}>Cmd+Enter to submit</span>
          <button className="feedback-submit-btn" onClick={submit} disabled={saving || !text.trim()}>
            {saving ? 'Saving…' : 'Add note'}
          </button>
        </div>
      </div>

      {unresolved.length > 0 && (
        <div className="feedback-section">
          <div className="feedback-section-header">
            <span className="feedback-section-title">Open ({unresolved.length})</span>
            <button className="feedback-copy-btn" onClick={copyFeedback}><Clipboard size={12} /> Copy all</button>
          </div>
          {unresolved.map(f => (
            <div key={f.id} className="feedback-item">
              <div className="feedback-item-text">{f.text}</div>
              <div className="feedback-item-footer">
                <span className="feedback-item-date">{f.created_at}</span>
                <button className="feedback-resolve-btn" onClick={() => resolve(f.id)}>Mark resolved</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {resolved.length > 0 && (
        <div className="feedback-section">
          <div className="feedback-section-title" style={{ marginBottom: 8 }}>Resolved ({resolved.length})</div>
          {resolved.map(f => (
            <div key={f.id} className="feedback-item feedback-item-resolved">
              <div className="feedback-item-text">{f.text}</div>
              <div className="feedback-item-date">{f.created_at}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
